import {kapitelDateString} from "@/graphql/kapitelTypes";
import date from "@/helper/datetime/date";

export class DateRange {
    min: kapitelDateString
    max: kapitelDateString

    constructor(min : kapitelDateString, max: kapitelDateString) {
        if (min > max) {
            throw new Error(`${min} - ${max} is not a valid range.`);
        }

        this.min = min
        this.max = max
    }

    getAllDates() : kapitelDateString[] {
        const result : kapitelDateString[] = [];
        let current = this.min
        while (current <= this.max) {
            result.push(current)
            current = date.addDays(current, 1)
        }
        return result
    }
}

export function formatRange(start: kapitelDateString, end: kapitelDateString): string {
    // same day → full short date once
    if (start === end) {
        return date.formatKapitelDate(start, "d.L.");
    }

    // same month → day-only for start, full for end (e.g., "1.–5.10.")
    if (date.isSameMonth(start, end)) {
        const s = date.formatKapitelDate(start, "d.");
        const e = date.formatKapitelDate(end, "d.L.");
        return `${s}–${e}`;
    }

    // different months → full short date for both (e.g., "30.9.–2.10.")
    const s = date.formatKapitelDate(start, "d.L.");
    const e = date.formatKapitelDate(end, "d.L.");
    return `${s}–${e}`;
}
